import React from 'react';
import Bodentemperatur from '../components/Bodentemperatur';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodentemperaturMatzen() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodentemperatur-matzen-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodentemperatur-matzen-heading">BODENTEMPERATUR</h1>
        </div>

        <Bodentemperatur ort="matzen" />
      </div>
    </div>
  );
}

export default BodentemperaturMatzen;
